module.exports = __webpack_public_path__ + "static/media/contractor-view-header.dbd18a26.jpg";